// src/components/common/IconButton.jsx
import React from 'react'

export default function IconButton({
    icon,
    variant = 'primary',
    size = 'medium',
    disabled = false,
    className = '',
    ...props
}) {
    const baseClasses = 'inline-flex items-center justify-center rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed'

    const variantClasses = {
        primary: 'bg-primary-600 text-white hover:bg-primary-700 focus:ring-primary-500',
        secondary: 'bg-secondary-200 text-secondary-800 hover:bg-secondary-300 focus:ring-secondary-500',
        outline: 'border border-primary-600 text-primary-600 hover:bg-primary-50 focus:ring-primary-500',
        ghost: 'text-gray-600 hover:bg-gray-100 focus:ring-gray-500',
    }

    const sizeClasses = {
        small: 'p-2',
        medium: 'p-3',
        large: 'p-4',
    }

    const iconSizes = {
        small: 'w-4 h-4',
        medium: 'w-5 h-5',
        large: 'w-6 h-6',
    }

    const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`

    return (
        <button
            className={classes}
            disabled={disabled}
            {...props}
        >
            <span className={iconSizes[size]}>{icon}</span>
        </button>
    )
}